import React from "react";
import "./BookingSection.css";

const meetings = [
  { id: 1, title: "Free 15 min Video Meeting", duration: 15, price: 0 },
  { id: 2, title: "Silver 30 min Video Meeting (Silver Badge)", duration: 30, price: 50 },
  { id: 3, title: "Gold 1 Hour Video Meeting (Gold Badge)", duration: 60, price: 200 },
];

const BookingSection = () => {
  const handleBooking = (meeting) => {
    const yourEmail = "contact@iqapexlabs.com";

    const calendarUrl = `https://calendar.google.com/calendar/r/eventedit?text=${encodeURIComponent(
      meeting.title
    )}&dates=${getGoogleCalendarDate(
      meeting.duration
    )}&details=Booked via IQApex Labs Website&add=${yourEmail}&sf=true`;

    window.open(calendarUrl, "_blank");
  };

  const getGoogleCalendarDate = (minutes) => {
    const start = new Date();
    const end = new Date(start.getTime() + minutes * 60000);
    const formatDate = (d) => d.toISOString().replace(/-|:|\.\d+/g, "");
    return `${formatDate(start)}/${formatDate(end)}`;
  };

  return (
    <section className="booking-section" aria-labelledby="booking-heading">

      {/* Section Heading (MATCHES ABOUT US STYLE) */}
      <header className="booking-header">
        <h2 id="booking-heading" className="section-title">
          Book Session</h2>
        <p className="section-subtitle">
          Choose a session that fits your needs and connect with our experts
        </p>
      </header>

      {/* Cards */}
      <div className="booking-container">
        {meetings.map((meeting) => (
          <article key={meeting.id} className="booking-card">
            <div className="rating">★ 5</div>

            <h3 className="card-title">{meeting.title}</h3>

            <div className="duration-price">
              <div className="duration">
                <span className="icon">📅</span>
                <div>
                  <strong>{meeting.duration} mins</strong>
                  <p>Video Meeting</p>
                </div>
              </div>

              <button
                className="price-btn"
                onClick={() => handleBooking(meeting)}
                aria-label={`Book ${meeting.title}`}
              >
                {meeting.price === 0 ? "Free" : `$${meeting.price}`}
                <span>→</span>
              </button>
            </div>
          </article>
        ))}
      </div>

      {/* Platinum Badge */}
      <div className="platinum-info">
        <h3>🌟 Platinum Badge</h3>
        <p>
          1 hour per week, one month & a capstone project →{" "}
          <strong>Earn Platinum Badge</strong>
        </p>
      </div>
    </section>
  );
};

export default BookingSection;
